<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-else>
      <v-simple-table class="ma-5">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">Produto</th>
            <th class="text-left">Quantidade</th>
            <th class="text-left">Código referência do fornecedor</th>
            <th class="text-left">Especificação</th>
            <th class="text-left">Observação interna</th>
            <th class="text-left">Observação externa</th>
          </tr>
          </thead>
          <tbody v-if="produtos.length > 0">
          <tr v-for="(produto, index) in produtos" :key="index">
            <td>
              <div>
                <px-span-tooltip v-if="produto.produto.codigo"
                                 top
                                 :text="`${produto.produto.codigo} - `"
                                 tooltip="Código interno"/>
                {{ descricaoItem(produto) }}
                <px-historico-preco-produto v-if="produto.produto"
                                            small
                                            :produto="produto.produto"
                                            :unidade-medida="produto.unidadeMedida"/>
              </div>
            </td>
            <td>
              {{ produto.quantidade | number(getCurrencyFormat(produto)) }}
                {{ produto.unidadeMedida.descricao }}
            </td>
            <td>
              <template v-if="produto.codigoFornecedor">
                {{ produto.produto.codigoFornecedor }}
              </template>
              <template v-else>
                Não informado
              </template>
            </td>
            <td>
              <template v-if="produto.especificacaoProduto">
                <px-span-tooltip top
                                 :text="especificacao(produto)"
                                 :tooltip="produto.especificacaoProduto"/>
              </template>
              <template v-else>
                Não informado
              </template>
            </td>
            <td>
              <template v-if="hasObservacaoInterna(produto)">
                <px-span-tooltip
                  top
                  :text="observacaoInternaLabel(produto)"
                  :tooltip="observacaoInternaTooltip(produto)"/>
              </template>
              <template v-else>
                Não informado
              </template>
            </td>
            <td>
              <template v-if="hasObservacaoExterna(produto)">
                <px-span-tooltip
                  top
                  :text="observacaoExternaLabel(produto)"
                  :tooltip="observacaoExternaTooltip(produto)"/>
              </template>
              <template v-else>
                Não informado
              </template>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <th colspan="6">
                <div class="text-center">
                  Não existem produtos nessa cotação
                </div>
              </th>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { CasaDecimalUtils } from 'px-components';
import CotacaoProdutoService from '../cotacao-produto-service';

export default {
  props: {
    cotacao: Object,
  },
  data() {
    return {
      produtos: [],
      loading: false,
    };
  },
  computed: {
    especificacao() {
      return item => Vue.filter('truncate')(item.especificacaoProduto, 15);
    },
    observacaoInternaLabel() {
      return (produto) => {
        if (produto.observacaoInterna) {
          return Vue.filter('truncate')(produto.observacaoInterna, 15);
        }
        return Vue.filter('truncate')(produto.produto.observacaoInterna, 15);
      };
    },
    observacaoExternaLabel() {
      return (produto) => {
        if (produto.observacaoExterna) {
          return Vue.filter('truncate')(produto.observacaoExterna, 15);
        }
        return Vue.filter('truncate')(produto.produto.observacaoExterna, 15);
      };
    },
    observacaoInternaTooltip() {
      return produto => produto.observacaoInterna ?? produto.produto.observacaoInterna;
    },
    observacaoExternaTooltip() {
      return produto => produto.observacaoExterna ?? produto.produto.observacaoExterna;
    },
    getCurrencyFormat() {
      return item => (item.produto ? CasaDecimalUtils.getCurrencyFormat(item.produto.casasDecimais)
        : CasaDecimalUtils.getCurrencyFormat(2));
    },
    descricaoItem() {
      return item => (item.produto ? item.produto.descricao : item.especificacaoProduto);
    },
    hasObservacaoExterna() {
      return produto => (produto.produto && produto.produto.observacaoExterna)
      || produto.observacaoExterna;
    },
    hasObservacaoInterna() {
      return produto => (produto.produto && produto.produto.observacaoInterna)
      || produto.observacaoInterna;
    },
  },
  methods: {
    getProdutos() {
      this.loading = true;
      CotacaoProdutoService.getProdutos(this.cotacao.id)
        .then(({ data }) => {
          this.produtos = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getProdutos();
  },
};
</script>
